/* eslint-disable @typescript-eslint/no-unused-vars */
import Header from 'components/Header/Index'
import React, { JSX, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { IRestaurantDetailData } from 'interfaces/restaurant'
import { restuarantData } from 'features/restaurant/restaurant'
import PaymentProgressOverlay from 'components/PaymentProgressOverlay/PaymentProgressOverlay'

interface ILayout {
  title?: string
  children: JSX.Element[] | JSX.Element
}
const Layout = ({ title, children }: ILayout) => {
  const restaurantData: IRestaurantDetailData = useSelector(restuarantData)

  useEffect(() => {
    if (title) document.title = title
  }, [title])

  // eslint-disable-next-line react-hooks/exhaustive-deps

  return (
    <>
      <Header
        restaurantName={restaurantData.restaurantName}
        areaName={restaurantData.establishmentName}
      />
      {children}
      {/* wrapper end */}
      <PaymentProgressOverlay />
    </>
  )
}

export default Layout
